<template>
    <div>
        <notificaciones></notificaciones>
        <router-view></router-view>
    </div>
</template>

<script>
    import Notificaciones from '@/components/Global/Notificaciones'

    export default {
        name: 'App',
        components: {
            Notificaciones
        },
        data: () => ({}),
        computed: {
            bus() { return this.$bus }
        },
        created() {
            document.body.setAttribute('data-app', true)
        },
    }
</script>

<style>
    .maxWidth { width: 81.8%; }
    .module-info { margin-top: -150px; }
    .clickable { cursor: pointer !important; }
    .align-center { text-align: center; }
    .negrita { font-weight: bold; }
    .enlace {
        color: #9be51a;
        cursor: pointer;
    }

    .mb-0 { margin-bottom: 0 !important; }
    .mb-1 { margin-bottom: 1rem !important; }
    .mb-2 { margin-bottom: 2rem !important; }
    .mb-3 { margin-bottom: 3rem !important; }
    .mb-4 { margin-bottom: 4rem !important; }
    .mb-8 { margin-bottom: 8rem !important; }
    .mt-1 { margin-top: 1rem !important; }
    .mt-2 { margin-top: 2rem !important; }
    .mt-3 { margin-top: 3rem !important; }
    .mt-4 { margin-top: 4rem !important; }
    .mt-8 { margin-top: 8rem !important; }
    .mt-n1 { margin-top: -0.5rem !important; }
    .mt-n2 { margin-top: -1rem !important; }
    .mt-n3 { margin-top: -2rem !important; }
    .mt-n4 { margin-top: -3rem !important; }

    .pl-0 { padding-left: 0 !important; }
    .pl-1 { padding-left: 1rem !important; }
    .pl-2 { padding-left: 2rem !important; }
    .pl-3 { padding-left: 3rem !important; }
    .pl-4 { padding-left: 4rem !important; }
    .pr-1 { padding-right: 1rem !important; }
    .pr-2 { padding-right: 2rem !important; }
    .pr-3 { padding-right: 3rem !important; }
    .pr-4 { padding-right: 4rem !important; }

    .title--l {
        line-height: 6rem;
    }
    .text--l {
        font-size: 1.5rem;
        line-height: 2.3rem;
        font-weight: 600;
        letter-spacing: 0.26px;
    }
</style>
